/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
	Box,
	Button,
	Center,
	Container,
	Flex,
	Input,
	InputGroup,
	InputRightElement,
	Table,
	Tbody,
	Td,
	Text,
	Tfoot,
	Th,
	Thead,
	Tooltip,
	Tr,
	useDisclosure,
} from '@chakra-ui/react';
import { faAddressBook, faFileExcel, faFileImport, faMoneyBillAlt, faTable, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/km';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { Link, useHistory, useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import OfficialProfileFilter from '../../components/MarketDevelopment/Miscellaneous/official-profile-filter';
import ExcelExportModal from '../../components/Modal/ExcelExportModal';
import ExcelExportModalEmployeeFSA from '../../components/Modal/ExcelExportModalEmployeeFSA';
import LoadingTable from '../../components/Table/Loading';
import c from '../../constant';
import useStore from '../../store';
import getPositionLabel from '../../utils/getPositionLabel';
import './style.css';
import ExcelEmployeeImport from '../../components/Modal/ExcelEmployeeImport';

const QUERY_EMPLOYEES = gql`
	query getEmployees($offset: Float, $limit: Float, $name: String, $isActive: Boolean, $department: String, $office: String) {
		getEmployees(name: $name, department: $department, office: $office, isActive: $isActive, pagerInput: { offset: $offset, limit: $limit }) {
			totalRows
			totalPages
			employees {
				id
				department
				office
				govtNumber
				fullName
				fullNameLatin
				gender
				dob
				createdAt
				phoneNumber
				currentWorkingStatus
				firstWorkingPlace
				additionalRoleOnCurrentJob
				active
				pob
				isPobManual
				pobManual
				currentAddress
				isCurrentAddressManual
				currentAddressManual
				email
				degree
				idCardNumber
				idCardExpirationDate
				spouseStatus
				childInformation
				generalEducation
				specialization
				inTheFieldOfPublicFunctions
				inThePrivateSector
				foreignLanguage
				active
				examCandidates
				latestRankStatus {
					id
					no
					rank
					dateOfLastRank
				}
				latestPositionStatus {
					id
					no
					position
					dateOfLastPosition
				}
			}
		}
	}
`;

const limit = 9999;

function UserList() {
	const { t } = useTranslation();
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const department = urlParams.get('department');
	const office = urlParams.get('office');
	const status = urlParams.get('status');
	const currentPage = urlParams.get('page') ? urlParams.get('page') : 1;
	const [username, setUsername] = useState('');
	const { currentLang } = useStore((state) => state.currentLang);
	const [loadEmployees, { loading, data }] = useLazyQuery(QUERY_EMPLOYEES);
	const modalExportFsa = useDisclosure();
	const modalExportExcel = useDisclosure();
	const modalImportExcel = useDisclosure();
	const [excelData, setExcelData] = useState([]);
	const [employees, setEmployees] = useState([]);

	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');

	useEffect(() => {
		window.scrollTo(0, 0);
		loadEmployeesWithVar();
	}, [location.search, currentPage]);

	useEffect(() => {
		if (data?.getEmployees?.employees?.length > 0) {
			setEmployees(orderEmployee(data?.getEmployees?.employees));
			setExcelData(
				orderEmployee(data?.getEmployees?.employees)?.map((item, index) => ({
					'ល.រ': index + 1,
					អត្ថលេខ: item?.govtNumber,
					'នាម-គោត្តនាម': item?.fullName,
					ភេទ: t(item?.gender),
					ថ្ងៃខែឆ្នាំកំណើត: item?.dob ? moment(item?.dob).format(c.excelDateOnlyTextFormat) : '',
					មុខងារ: item?.currentWorkingStatus?.currentWorkingStatusPosition
						? getPositionLabel(item?.currentWorkingStatus?.currentWorkingStatusPosition)
						: '',
					ឋានៈស្មើ: getStatusJobTitleWithEmptyBlank(item?.currentWorkingStatus?.currentWorkingStatusJobTitle),
					'ក្របខ័ណ្ឌ ឋានន្តរស័កិ្ត​ និងថ្នាក់': item?.firstWorkingPlace?.firstWorkingJobTitle,
					ថ្ងៃខែឆ្នាំចូលបំរើការងាររដ្ឋ: item?.firstWorkingPlace?.firstWorkingstartDate
						? moment(item?.firstWorkingPlace?.firstWorkingstartDate).format(c.excelDateOnlyTextFormat)
						: '',
					លេខទូរសព្ទ: t(item?.phoneNumber),
					ស្ថានភាព: item?.active ? t('Active') : t('Inactive'),
				})),
			);
		}
	}, [data]);

	function handlePageClick(data) {
		let selected = data.selected;
		const page = selected + 1;
		history.push(`/employee/list?page=${page}`);
	}

	function loadEmployeesWithVar() {
		const variables = {
			offset: currentPage ? (currentPage - 1) * limit : 0,
			limit,
			name: username,
			isActive: status === 'active' ? true : status === 'inactive' ? false : null,
			department,
			office,
		};
		loadEmployees({ variables });
	}

	function handleSearch() {
		handlePageClick({ selected: 0 });
		loadEmployeesWithVar();
	}

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			handlePageClick({ selected: 0 });
			loadEmployeesWithVar();
		}
	};

	function getStatusEqualTo(data) {
		let tmpData = _.orderBy(data, ['date'], ['desc']);
		return tmpData?.[0]?.title;
	}

	function orderEmployee(employees) {
		const tmpEmp = [];
		employees?.forEach((item) => {
			tmpEmp.push({ ...item, currentWorkingStatusPosition: parseInt(item?.currentWorkingStatus?.currentWorkingStatusPosition || 99) });
		});
		return _.orderBy(tmpEmp, ['currentWorkingStatusPosition', 'createdAt'], ['asc', 'asc']);
	}

	function getStatusJobTitle(statusJobTitle) {
		if (statusJobTitle) {
			switch (statusJobTitle) {
				case 'Level_7':
					return 'អនុមន្រ្តីកម្រិត១';
				case 'Level_6':
					return 'អនុមន្រ្តីកម្រិត២';
				case 'Level_5':
					return 'អនុមន្រ្តីកម្រិត៣';
				case 'Level_4':
					return 'នាយក្រមការ';
				case 'Level_3':
					return 'ក្រមការដើមខ្សែ';
				case 'Level_2':
					return 'ក្រមការ';
				case 'Level_1':
					return 'កម្មសិក្សា';
				default:
					return statusJobTitle;
			}
		} else {
			return '-';
		}
	}

	function getStatusJobTitleWithEmptyBlank(statusJobTitle) {
		if (statusJobTitle) {
			switch (statusJobTitle) {
				case 'Level_7':
					return 'អនុមន្រ្តីកម្រិត១';
				case 'Level_6':
					return 'អនុមន្រ្តីកម្រិត២';
				case 'Level_5':
					return 'អនុមន្រ្តីកម្រិត៣';
				case 'Level_4':
					return 'នាយក្រមការ';
				case 'Level_3':
					return 'ក្រមការដើមខ្សែ';
				case 'Level_2':
					return 'ក្រមការ';
				case 'Level_1':
					return 'កម្មសិក្សា';
				default:
					return statusJobTitle;
			}
		} else {
			return '';
		}
	}

	const candidateLength = employees.filter((a) => a?.examCandidates)?.length;

	return (
		<>
			<Container maxW="container.xl" mt="16px" mb="16px">
				<BreadcrumbComponent
					list={[
						{
							name: t('OFFICIAL PROFILE'),
							path: '#',
						},
					]}
				/>
				<Center mt="5">
					<Box
						w="100%"
						bg="white"
						borderRadius={c.borderRadius}
						border="1px solid #dbdbdb"
						boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
						pb="32px"
					>
						<Flex bg="#FAFAFA" p="16px" pt="8px" pb="8px" mb="16px" justifyContent="space-between" borderBottom="1px solid #dbdbdb">
							<Text fontSize="x-large" fontWeight="bold">
								{t('Officials List')}
							</Text>
							<Flex alignItems="center">
								<Tooltip label={t('Import')}>
									<Flex onClick={modalImportExcel?.onOpen} mr="3" cursor="pointer">
										<FontAwesomeIcon icon={faFileImport} style={{ fontSize: 16, marginLeft: 6 }} />
									</Flex>
								</Tooltip>
								<Tooltip label={t('Officials Position List')}>
									<Flex onClick={() => history.push(`/officials-list-position`)} mr="3" cursor="pointer">
										<FontAwesomeIcon icon={faAddressBook} style={{ fontSize: 16, marginLeft: 6 }} />
									</Flex>
								</Tooltip>
								<Tooltip label={t('Officials Rank List')}>
									<Flex>
										<Flex onClick={() => history.push(`/officials-list-rank`)} mr="3" cursor="pointer">
											<FontAwesomeIcon icon={faUsers} style={{ fontSize: 16, marginLeft: 6 }} />
										</Flex>
										<Text
											color="red"
											fontSize="14px"
											fontWeight="bold"
											ml="26px"
											mt="-10px"
											_hover={{ cursor: 'default' }}
											position="absolute"
										>
											{candidateLength}
										</Text>
									</Flex>
								</Tooltip>
								<Tooltip label={t('Export To Excel for FSA')}>
									<Flex onClick={modalExportFsa?.onOpen} mr="3" cursor="pointer">
										<FontAwesomeIcon icon={faTable} style={{ fontSize: 16, marginLeft: 6 }} />
									</Flex>
								</Tooltip>
								<Tooltip label={t('Export To Excel')}>
									<Flex onClick={modalExportExcel?.onOpen} mr="3" cursor="pointer">
										<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16, marginLeft: 6 }} />
									</Flex>
								</Tooltip>

								<Tooltip label={t('Salary')}>
									<Link to={`/salary/list?page=1`}>
										<FontAwesomeIcon icon={faMoneyBillAlt} style={{ fontSize: 16, marginLeft: 6, marginRight: '12px' }} />
									</Link>
								</Tooltip>
								<InputGroup mr="3" size="md" w="210px">
									<Input
										onKeyDown={handleKeyDown}
										pr="4.5rem"
										placeholder={t('Name')}
										value={username}
										onChange={(e) => setUsername(e.target.value)}
									/>
									<InputRightElement zIndex={0} width="4.5rem">
										<Button h="1.75rem" size="sm" onClick={handleSearch}>
											{t('Search')}
										</Button>
									</InputRightElement>
								</InputGroup>
								<Box mr={2}>
									<OfficialProfileFilter
										status={status ?? 'all'}
										department={department}
										office={office}
										onCallback={(filterUrl) => {
											history.push(`/employee/list${filterUrl}`);
										}}
									/>
								</Box>
							</Flex>
						</Flex>

						<Box p="16px">
							<Table variant="simple">
								<Thead>
									<Tr>
										<Th>អត្ថលេខ</Th>
										<Th>នាម-គោត្តនាម</Th>
										<Th>ភេទ</Th>
										<Th>ថ្ងៃខែឆ្នាំកំណើត</Th>
										<Th>មុខងារ</Th>
										<Th>ឋានៈស្មើ</Th>
										<Th>ក្របខ័ណ្ឌ ឋានន្តរស័កិ្ត​ និងថ្នាក់</Th>
										<Th>ថ្ងៃខែឆ្នាំចូលបំរើការងាររដ្ឋ</Th>
										<Th>លេខទូរសព្ទ</Th>
										<Th>ស្ថានភាព</Th>
									</Tr>
								</Thead>
								<Tbody>
									{loading && <LoadingTable column={10} />}
									{data?.getEmployees?.employees.length <= 0 && (
										<Tr>
											<Td>
												<Text>{t('No Data')}</Text>
											</Td>
										</Tr>
									)}
									{orderEmployee(data?.getEmployees?.employees)?.map((item, index) => {
										return (
											<Tr
												key={`item-${index}`}
												cursor="pointer"
												_hover={{ bg: 'gray.200' }}
												onClick={() => history.push(`/employee/detail?id=${item.id}`)}
											>
												{/* <Td></Td> */}
												<Td>{item?.govtNumber || '-'}</Td>
												<Td>{item?.fullName}</Td>
												<Td>{t(item?.gender || '-')}</Td>
												<Td>{item?.dob ? moment(item?.dob).format(c.excelDateOnlyTextFormat) : '-'}</Td>
												<Td>
													{item?.latestPositionStatus?.position
														? getPositionLabel(item?.latestPositionStatus?.position)
														: item?.currentWorkingStatus?.currentWorkingStatusPosition
															? getPositionLabel(item?.currentWorkingStatus?.currentWorkingStatusPosition)
															: '-'}
												</Td>
												<Td>{getStatusEqualTo(item?.additionalRoleOnCurrentJob) || '-'}</Td>
												<Td>
													{item?.latestRankStatus?.rank
														? getStatusJobTitle(item?.latestRankStatus?.rank)
														: item?.currentWorkingStatus?.currentWorkingStatusJobTitle
															? getStatusJobTitle(item.currentWorkingStatus.currentWorkingStatusJobTitle)
															: '-'}
												</Td>
												<Td>
													{item?.firstWorkingPlace?.firstWorkingstartDate
														? moment(item?.firstWorkingPlace?.firstWorkingstartDate).format(c.excelDateOnlyTextFormat)
														: '-'}
												</Td>
												<Td>{t(item?.phoneNumber) || '-'}</Td>
												<Td color={item?.active ? '#1e8449' : '#e74c3c'}>{item?.active ? t('Active') : t('Inactive')}</Td>
											</Tr>
										);
									})}
								</Tbody>
								<Tfoot>
									<Tr>
										<Th>អត្ថលេខ</Th>
										<Th>នាម-គោត្តនាម</Th>
										<Th>ភេទ</Th>
										<Th>ថ្ងៃខែឆ្នាំកំណើត</Th>
										<Th>មុខងារ</Th>
										<Th>ឋានៈស្មើ</Th>
										<Th>ក្របខ័ណ្ឌ ឋានន្តរស័កិ្ត​ និងថ្នាក់</Th>
										<Th>ថ្ងៃខែឆ្នាំចូលបំរើការងាររដ្ឋ</Th>
										<Th>លេខទូរសព្ទ</Th>
										<Th>ស្ថានភាព</Th>
									</Tr>

									<Tr>
										<Th colSpan={10} isNumeric>
											{t('Total Rows')}: {data?.getEmployees?.totalRows}
										</Th>
									</Tr>
								</Tfoot>
							</Table>
							<Flex justifyContent="flex-end" w="100%" mt="4">
								{data?.getEmployees?.totalPages > 1 && (
									<ReactPaginate
										previousLabel={<ChevronLeftIcon fontSize="20px" />}
										nextLabel={<ChevronRightIcon fontSize="20px" />}
										breakLabel={'...'}
										breakClassName={'break-me'}
										pageCount={data?.getEmployees?.totalPages}
										marginPagesDisplayed={2}
										pageRangeDisplayed={3}
										onPageChange={handlePageClick}
										containerClassName={'pagination'}
										activeClassName={'active'}
										initialPage={(currentPage - 1) | 0}
									/>
								)}
							</Flex>
						</Box>
					</Box>
				</Center>
			</Container>
			{modalExportExcel?.isOpen && excelData?.length > 0 && (
				<ExcelExportModal isOpen={true} onClose={modalExportExcel?.onClose} title="IRC" data={excelData} />
			)}
			{modalExportFsa?.isOpen && employees?.length > 0 && (
				<ExcelExportModalEmployeeFSA employees={employees} isOpen={true} onClose={modalExportFsa?.onClose} />
			)}
			{modalImportExcel?.isOpen && <ExcelEmployeeImport isOpen={true} onClose={modalImportExcel?.onClose} />}
		</>
	);
}

export default UserList;
